import { Users, Briefcase, CheckSquare, FileText } from 'lucide-react'
import type { SearchResult } from '../types/search.types'

interface SearchResultItemProps {
  result: SearchResult
  isSelected: boolean
  onClick: () => void
}

const iconMap = {
  client: Users,
  engagement: Briefcase,
  task: CheckSquare,
  document: FileText,
}

export function SearchResultItem({ result, isSelected, onClick }: SearchResultItemProps) {
  const Icon = iconMap[result.type]

  return (
    <div
      className={`search-result-item ${isSelected ? 'selected' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <Icon size={20} style={{ color: 'var(--text-secondary)' }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 500, color: 'var(--text-primary)' }}>
          {result.title}
        </div>
        {result.subtitle && (
          <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--text-tertiary)' }}>
            {result.subtitle}
          </div>
        )}
      </div>
      <span className="search-type-badge">
        {result.type}
      </span>
    </div>
  )
}
